import { apiSlice } from 'api/apiSlice';
import { endpoints } from 'helper/endpoints';

// Re-auth device-link sends authenticate with a per-request session header
// instead of the bearer token used by the main verification flow.
const reauthSessionHeader = (sessionId) => ({ 'X-Reauthenticate-Session': sessionId });

export const commonApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        sendPhoneLink: builder.mutation({
            query: (data) => ({
                url: endpoints.requestPhoneLink,
                method: 'POST',
                data,
            }),
        }),
        sendEmailLink: builder.mutation({
            query: (data) => ({
                url: endpoints.requestEmailLink,
                method: 'POST',
                data,
            }),
        }),
        sendReauthPhoneLink: builder.mutation({
            query: ({ sessionId, ...data }) => ({
                url: endpoints.reauthenticateRequestPhone,
                method: 'POST',
                data,
                headers: reauthSessionHeader(sessionId),
            }),
        }),
        sendReauthEmailLink: builder.mutation({
            query: ({ sessionId, ...data }) => ({
                url: endpoints.reauthenticateRequestEmail,
                method: 'POST',
                data,
                headers: reauthSessionHeader(sessionId),
            }),
        }),
    }),
    overrideExisting: true,
});

export const {
    useSendPhoneLinkMutation,
    useSendEmailLinkMutation,
    useSendReauthPhoneLinkMutation,
    useSendReauthEmailLinkMutation,
} = commonApi;
